export class ParamsAccessor {
  constructor() {
  }
}
